import type { ReportDataTableColumn } from '../../components/ReportDataTable'
import type { ConfiguredReportReportRow } from '../../types/pages'
import { display, formatDateTime, fullName } from '../../utils/configuredReportFormatters'

export const propertyActivityColumns: ReportDataTableColumn<ConfiguredReportReportRow, string>[] = [
  {
    id: 'company_name',
    label: 'Company',
    sortKey: 'company_name',
    render: (row) => display(row.company_name),
  },
  {
    id: 'property_name',
    label: 'Property',
    sortKey: 'property_name',
    render: (row) => display(row.property_name),
  },
  {
    id: 'address',
    label: 'Address',
    sortKey: 'address',
    render: (row) =>
      display(row.address ?? row.property_address ?? row.company_address),
  },
  {
    id: 'contact_name',
    label: 'Contact Name',
    sortKey: 'first_name',
    render: (row) =>
      display(row.contact_name) !== '—'
        ? display(row.contact_name)
        : fullName(row.first_name, row.last_name),
  },
  {
    id: 'contact_email',
    label: 'Contact Email',
    sortKey: 'email',
    render: (row) => display(row.contact_email ?? row.email),
  },
  {
    id: 'role_name',
    label: 'Role Name',
    sortKey: 'role_name',
    render: (row) => display(row.role_name),
  },
  {
    id: 'team_name',
    label: 'Team Name',
    sortKey: 'team_name',
    render: (row) => display(row.team_name ?? row.teamname),
  },
  {
    id: 'last_login',
    label: 'Last Login',
    sortKey: 'last_login_date',
    render: (row) => formatDateTime(row.last_login_date ?? row.last_login),
  },
]
